import { UiText } from "@frontend/roz-uikit";

import { PersonalDataForm } from "./PersonalDataForm";

export const PersonalData = () => (
  <div className="sdkui:mx-auto sdkui:max-w-110 sdkui:space-y-4">
    <UiText className="sdkui:text-center sdkui:text-2xl">
      Настройте свой профиль
    </UiText>
    <PersonalDataForm />
  </div>
);
